import { CommonModule } from '@angular/common';
import { Component, inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MatToolbar } from '@angular/material/toolbar';
import { TranslateModule } from '@ngx-translate/core';
import { ButtonComponent } from 'ui-library';

// Shown right before creating one or several KYD whose name already belongs to an existing
// tracker (see kyd-bulk-add-dialog.component.ts's save()) - the backend enforces a unique name
// per project, but silently proceeding (or, on mobile, updating whichever existing record
// happens to share the name) would replace that KYD's own settings without the user ever being
// told. Continuing here is an explicit, informed choice instead.
@Component({
  selector: 'app-kyd-duplicate-name-dialog',
  imports: [CommonModule, TranslateModule, MatDialogModule, MatIconModule, MatToolbar, ButtonComponent],
  standalone: true,
  templateUrl: './kyd-duplicate-name-dialog.component.html',
  styleUrls: ['./kyd-duplicate-name-dialog.component.scss']
})
export class KydDuplicateNameDialogComponent {
  readonly data: { names: string[] } = inject(MAT_DIALOG_DATA);
  readonly dialogRef: MatDialogRef<KydDuplicateNameDialogComponent, boolean> = inject(MatDialogRef<KydDuplicateNameDialogComponent, boolean>);

  get messageKey(): string {
    return this.data.names.length > 1 ? 'trackers.duplicate_name_message_plural' : 'trackers.duplicate_name_message';
  }

  choose(proceed: boolean) {
    this.dialogRef.close(proceed);
  }
}
